import { colors, fonts } from 'theme'
import css from 'styled-jsx/css'

export const modal = css`
  h1{
    margin: 2rem 5.375rem 0;
    font-size: 1.5rem;
    font-weight: ${fonts.bold};
    text-align: center;
    color: ${colors.secondary};
  }

  h4{
    margin: 0 5.375rem;
    font-size: 1.25rem;
    font-weight: ${fonts.semiBold};
    line-height: 2.45;
    text-align: center;
    color: ${colors.secondary};
  }
   @media screen and (max-width: 992px) and (min-width: 320px) {
    h1{
      margin: 0 1rem;
    }

    h4{
      margin: 0 1rem;
    }
   }
  `
